import { lazy } from "react";
import { enumPermisosRecaudoGenerico } from "./enumPermisosRecaudoGenerico";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

/**
 * Recaudo Génerico
 */
const RecaudoGenericoPdp = lazy(() => import("./RecaudoGenericoPDP"));

const ManualRecaudoGenerico = lazy(() =>
  import(
    "./Views/RecaudoGenericoServiciosPublicosPrivados/ManualRecaudoGenerico"
  )
);
const CodigoBarrasRecaudoGenerico = lazy(() =>
  import(
    "./Views/RecaudoGenericoServiciosPublicosPrivados/CodigoBarrasRecaudoGenerico"
  )
);

const SeleccionConvenioRecaudoGenerico = lazy(() =>
  import(
    "./Views/RecaudoGenericoServiciosPublicosPrivados/SeleccionConvenioRecaudoGenerico"
  )
);

const DevolucionRecaudoSinEfectivoNav = lazy(() => import("./DevolucionRecaudoSinEfectivoAdministradorNav"));
const DevolucionPPSE = lazy(() => import("./Views/DevolucionRecaudoSinEfectivo/DevolucionPortalPagosSinEfectivo"));

const GeneracionQRPortalPagos = lazy(() => import("./Views/PortalPagos/GeneracionQRPortalPagos"));

export const listPermissionsRecaudoGenerico = Object.values(
  enumPermisosRecaudoGenerico
);

const rutasRecaudoGenericoPDP = {
  //RecaudoGenericoPdp
  link: "/recaudo-generico",
  label: (
    <AppIcons
      Logo={"RECAUDO_AGILIZA_TU_PAGO"}
      name="Agiliza tu Pago"
    />
  ),
  component: RecaudoGenericoPdp,
  permission: listPermissionsRecaudoGenerico,
  subRoutes: [
    {
      link: "/recaudo-generico/manual",
      label: <AppIcons Logo={"RECAUDO_MANUAL_AGILIZA_TU_PAGO"} name="Recaudo manual" />,
      component: SeleccionConvenioRecaudoGenerico,
      permission: [enumPermisosRecaudoGenerico.RECAUDO_GENERICO],
    },
    {
      link: "/recaudo-generico/codigo-barras",
      label: (
        <AppIcons
          Logo={"RECAUDO_CODIGO_DE_BARRAS"}
          name="Recaudo código de barras"
        />
      ),
      component: CodigoBarrasRecaudoGenerico,
      permission: [enumPermisosRecaudoGenerico.RECAUDO_GENERICO],
    },
    {
      link: "/recaudo-generico/trx-recaudo",
      label: <AppIcons Logo={"RECAUDO_AGILIZA_TU_PAGO"} name="Recaudo manual" />,
      component: ManualRecaudoGenerico,
      permission: [enumPermisosRecaudoGenerico.RECAUDO_GENERICO],
      show: false,
    },
  ],
};

export const rutasDevolucionRecaudoSinEfectivoOperaciones = {
  link: "/GestionTransaccional/devolucion-recaudo-sin-efectivo",
  label: <AppIcons Logo={"RECAUDO"} name="Devolución Recaudo Sin Efectivo" />,
  component: DevolucionPPSE,
  permission: [enumPermisosRecaudoGenerico.DEBOLUCION_RECAUDO_GENERICO],
  subRoutes: [],
};

export default rutasRecaudoGenericoPDP;

export const rutaGeneracionQRPortalPagos = {
  link: "/generacion_qr_portal_pagos",
  label: (
    <AppIcons
      Logo={"DAVIVIENDA_RECAUDO_CODIGO_DE_BARRAS"}
      name={"Descargar Código QR Portal de Pagos"}
    />
  ),
  component: GeneracionQRPortalPagos,
  permission: [enumPermisosRecaudoGenerico.GENERACION_QR_PORTAL_PAGOS],
  subRoutes: [],
};